@if (!printMode) {
  <lib-validation-problems [saving$]="saving$"></lib-validation-problems>
}

@if (uiConfiguration.hasReferenceRegistrationInformation) {
  <div>
    <h3>{{ 'common.labels.existingRegistrationDetails' | transloco }}</h3>
    <lib-existing-registration-details
      [uiConfiguration]="uiConfiguration.referenceRegistrationInformationUIConfiguration!">
    </lib-existing-registration-details>
  </div>
}

@if (uiConfiguration.hasRenewalDetails) {
  <h3>{{ 'common.labels.typeDetails' | transloco: { type: order.orderType.name } }}</h3>
}
@if (uiConfiguration.hasRenewalDetails) {
  <div class="flex-item-no-padding">
    <div class="margin-bottom-5">
      @if (uiConfiguration.lienDetailsConfiguration!.showQCFormTypeID) {
        <div class="flex-container">
          <span class="flex-item-3">{{ 'orders.formType' | transloco }}</span>
          <span class="flex-item-4" data-testid="lien-details-form-type-text">{{ order.lien?.qcFormTypeID }}</span>
        </div>
      }
      @if ((uiConfiguration.renewalDetailsConfiguration!.showTerm || uiConfiguration.renewalDetailsConfiguration!.showInfinityTerm) && (order.lien?.term || order.lien?.isInfiniteTerm)) {
        <div class="flex-container">
          <span class="flex-item-3">{{ 'orders.term' | transloco }}</span>
          <span class="flex-item-4" data-testid="lien-details-term-text">{{ order.lien?.isInfiniteTerm ? "INFINITY" : order.lien?.term }}</span>
        </div>
      }
      @if (uiConfiguration.renewalDetailsConfiguration!.showTerm && uiConfiguration.renewalDetailsConfiguration!.registryDefinedTerm) {
        <div class="flex-container">
          <span class="flex-item-3">{{ 'orders.term' | transloco }}</span>
          <span class="flex-item-4" data-testid="lien-details-term-text">{{ uiConfiguration.lienDetailsConfiguration!.registryDefinedTerm }}</span>
        </div>
      }
      @if (uiConfiguration.renewalDetailsConfiguration!.showExpiryDate && !order.lien?.term && !order.lien?.isInfiniteTerm) {
        <div class="flex-container">
          <span class="flex-item-3">{{ getExpiryDateHeader() }}</span>
          <span class="flex-item-4" data-testid="lien-details-expiry-date-text">{{ $safeNavigationMigration(order.lien?.expiryDate) | localizedDate: 'yyyy-MM-dd' }}</span>
        </div>
      }
    </div>
  </div>
}
@if (isHistorical()) {
  <lib-lien-results [uiConfiguration]="uiConfiguration.lienDetailsConfiguration!"
    [results]="$safeNavigationMigration(order.lien?.registrationResults?.at(0))"
    class="flex-item">
  </lib-lien-results>
}